import {
  ThemeProvider,
  createTheme,
  CssBaseline,
  Typography,
} from "@mui/material";
import "./index.css";
import Routing from "./Routing";
import Header from "./components/layout/header";
import Footer from "./components/layout/footer";
import { ToastContainer } from "react-toastify";
import { ErrorBoundary } from "react-error-boundary";
import "react-toastify/dist/ReactToastify.css";

function App() {
  const theme = createTheme({
    palette: {
      mode: "dark",
      background: {
        default: "#1d1d1d",
      },
    },
    typography: {
      fontFamily: '"Roboto Mono", monospace;',
    },
  });

  return (
    <ThemeProvider theme={theme}>
      <ErrorBoundary
        fallback={<Typography variant="h3">Something went wrong</Typography>}
      >
        <Header />
        <Routing />
        <ToastContainer
          position="top-center"
          autoClose={4000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="dark"
        />
        <CssBaseline />
        <Footer />
      </ErrorBoundary>
    </ThemeProvider>
  );
}

export default App;
